// FranchisePageCommercial
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ArrowRight, ArrowLeft ,LocateFixed,LucidePersonStanding} from "lucide-react";
import { DeclareTransferModalAdminV } from "../Admin_V/Modals/DeclareTransferAdminV";
import {RecupererTransfert} from "../Admin_V/Modals/RécupérerTransfert"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput,
  Button,
  Spinner,
  Select,
} from "flowbite-react";
import LoadingModal from "../utils/LoadingModal";
import { ErrorInfo } from "../utils/ErrorInfo";


export function FranchisePageCommercial() {
  const [pagination, setPagination] = useState({
    total: 0,
    page: 1,
    pages: 1,
    limit: 10,
  });

  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sender: "",
    receiver: "",
    dateFrom: "",
    dateTo: "",
    batchName: "",
    quantityMin: "",
    quantityMax: "",
    terminationDateFrom: "",
    terminationDateTo: "",
    first_iccid: "",
    last_iccid: "",
    status: "",
    type: "",
  });
  const [loading, setLoading] = useState(false);
  const [franchise, setFranchise] = useState(null);
  const [currentCommercial, setCurrentCommercial] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [stockBeingSent, setStockBeingSent] = useState(0);
  const { id } = useParams();
  const [isDeclareTransferModalOpen, setIsDeclareTransferModalOpen] =
    useState(false);
  const [isRecupereTransModalOpen, setIsRecupereTransModalOpen] =
    useState(false);
  const [error, setError] = useState("");
  const [errorInfo, setErrorInfo] = useState({
    isVisible: false,
    errorMessage: "",
  });

  const getfullinfo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        const commercialInfo = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}commercial/${response.data?.data?._id}`,
          { withCredentials: true }
        );
        setCurrentCommercial(commercialInfo.data);

        const franchiseInfo = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}franchise/${id}`,
          { withCredentials: true }
        );
        setFranchise(franchiseInfo.data);
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Erreur lors de la récupération des informations"
      );
      setErrorInfo({
        isVisible: true,
        errorMessage:
          error.response?.data?.message ||
          "Erreur lors de la récupération des informations",
      });
    }
    setLoading(false);
  };

  const getUserRelatedTransactions = async () => {
    if (!franchise?.user) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}userRelatedTransactions`,
        {
          params: {
            ...filters,
            targetUserId: franchise.user,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setTransactions(response.data.data);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Erreur lors de la récupération des transactions"
      );
      setErrorInfo({
        isVisible: true,
        errorMessage:
          error.response?.data?.message ||
          "Erreur lors de la récupération des transactions",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      page: 1, // Reset to first page when filter changes
    }));
  };

  const handlePageChange = (newPage) => {
    setFilters((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  // Modal handlers
  const openDeclareTransferModal = () => setIsDeclareTransferModalOpen(true);
  const closeDeclareTransferModal = () => setIsDeclareTransferModalOpen(false);
  const closeSuccesDeclareTransferModal = () => {
    setIsDeclareTransferModalOpen(false);

    getfullinfo();
  };

  const openRecuperTransferModal = () => setIsRecupereTransModalOpen(true);
  const closeRecuperTransferModal = () => setIsRecupereTransModalOpen(false);
  const closeSuccesRecuperTransferModal = () => {
    setIsRecupereTransModalOpen(false);
    getfullinfo();
  };

  const getUserPendingTransactionsAmount = async () => {
    if (!franchise?.user) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}userPendingTransactionsAmount`,
        {
          params: {
            targetUserId: franchise.user,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setStockBeingSent(response.data.totalPendingAmount);
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Erreur lors de la récupération des transactions"
      );
      setErrorInfo({
        isVisible: true,
        errorMessage:
          error.response?.data?.message ||
          "Erreur lors de la récupération des transactions",
      });
    }
  };

  useEffect(() => {
    getfullinfo();
  }, []);

  useEffect(() => {
    if (franchise?.user) {
      getUserRelatedTransactions();
      getUserPendingTransactionsAmount();
    }
  }, [filters, franchise]);

  return (
    <>
      {errorInfo.isVisible && (
        <ErrorInfo
          onClose={() => setErrorInfo({ ...errorInfo, isVisible: false })}
          errorMessage={error}
        />
      )}

      {loading && <LoadingModal />}

      {franchise && currentCommercial && (
        <div className="dark:bg-gray-900">
          {/* Header Section */}
          <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-1 2xl:grid-cols-1 mb-4">
            <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
              <div className="w-full sm:w-1/2 p-2">
                <div className="flex items-center mb-2">
                  <LocateFixed className="h-5 w-5 text-gray-500 dark:text-gray-400 mr-2" />
                  <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                    {franchise?.pos_franchise_id?.name}
                  </h3>
                </div>
                <div className="flex items-center mb-2">
                  <LucidePersonStanding className="h-5 w-5 text-gray-500 dark:text-gray-400 mr-2" />
                  <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                    {franchise.owner}
                  </h3>
                </div>
                <span className="text-sm font-bold leading-none text-gray-900 dark:text-white">
                  {"Commercial Attaché"  + " : " + franchise?.commercial?.FirstName + " " + franchise?.commercial?.LastName}
                </span>
              </div>
              <div className="w-full sm:w-1/2 p-2 flex flex-col sm:flex-row justify-end">
                <button
                  onClick={openDeclareTransferModal}
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 sm:mb-0 sm:me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800"
                >
                  <span className="w-full relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    Déclarer un transfert
                  </span>
                </button>

                <button
                  onClick={openRecuperTransferModal}
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 sm:mb-0 sm:me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-red-500 to-red-800 group-hover:from-red-500 group-hover:to-black-800 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-red-200 dark:focus:ring-red-800"
                >
                  <span className="w-full relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    Déclarer un recouvrement
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-3 2xl:grid-cols-2 mb-4">
            <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
              <div className="w-full">
                <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                  Stock
                </h3>
                <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                  {franchise.StockTotal}
                </span>
              </div>
            </div>
            <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
              <div className="w-full">
                <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                  Stock sortant en attente d'acceptation
                </h3>
                <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                  {stockBeingSent}
                </span>
              </div>
            </div>
          </div>

          {/* Filters and Table Section */}
          <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-1 2xl:grid-cols-1 mb-4 dark:bg-gray-900 dark:text-white bg-white p-4 rounded-md shadow-sm">
            {/* Filters */}
            <div className="mb-4 grid grid-cols-1 md:grid-cols-4 gap-4">
              <Select
                value={filters.status}
                onChange={(e) => handleFilterChange("status", e.target.value)}
                size={"xs"}
              >
                <option value="">Tous les statuts</option>
                <option value="accepté">Accepté</option>
                <option value="rejeté">Rejeté</option>
                <option value="en attente">En attente</option>
              </Select>

              <Select
                value={filters.type}
                onChange={(e) => handleFilterChange("type", e.target.value)}
                size={"xs"}
              >
                <option value="">Tous les types</option>
                <option value="affectation">Affectation</option>
                <option value="recouvrement">Recouvrement</option>
              </Select>
              {/* Add new sender/receiver filters */}
              <TextInput
                type="text"
                value={filters.sender}
                onChange={(e) => handleFilterChange("sender", e.target.value)}
                placeholder="Rechercher expéditeur"
                size={"xs"}
              />

              <TextInput
                type="text"
                value={filters.receiver}
                onChange={(e) => handleFilterChange("receiver", e.target.value)}
                placeholder="Rechercher destinataire"
                size={"xs"}
              />
              <TextInput
                type="date"
                value={filters.dateFrom}
                onChange={(e) => handleFilterChange("dateFrom", e.target.value)}
                placeholder="Date début"
                size={"xs"}
              />

              <TextInput
                type="text"
                value={filters.batchName}
                onChange={(e) =>
                  handleFilterChange("batchName", e.target.value)
                }
                placeholder="Nom du batch"
                size={"xs"}
              />
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <Table striped>
                <TableHead>
                  <TableHeadCell>Type</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Expéditeur</TableHeadCell>
                  <TableHeadCell>Destinataire</TableHeadCell>
                  <TableHeadCell>Premier ICCID</TableHeadCell>
                  <TableHeadCell>Dernier ICCID</TableHeadCell>
                  <TableHeadCell>Quantité</TableHeadCell>
                  <TableHeadCell>Batch</TableHeadCell>
                  <TableHeadCell>Date</TableHeadCell>
                </TableHead>

                <TableBody className="divide-y">
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={9} className="text-center">
                        <Spinner />
                      </TableCell>
                    </TableRow>
                  ) : transactions.length ? (
                    transactions.map((transaction) => (
                      <TableRow
                        key={transaction._id}
                        className="bg-white dark:border-gray-700 dark:bg-gray-800 text-xs font-bold"
                      >
                        <TableCell>{transaction.type}</TableCell>
                        <TableCell>{transaction.status}</TableCell>
                        <TableCell>{transaction.sender?.username}</TableCell>
                        <TableCell>{transaction.receiver?.username}</TableCell>
                        <TableCell>{transaction.first_iccid}</TableCell>
                        <TableCell>{transaction.last_iccid}</TableCell>
                        <TableCell>{transaction.quantity}</TableCell>
                        <TableCell>
                          {transaction.batch_id?.batch_name}
                        </TableCell>
                        <TableCell>
                          {new Date(transaction.createdAt).toLocaleDateString()}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow className="dark:bg-gray-800 text-xs font-bold">
                      <TableCell colSpan={9} className="text-center">
                        Aucune transaction trouvée
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            {/* Pagination */}
            <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
              <div className="flex justify-center items-center gap-2">
                <Button
                  disabled={pagination.page === 1}
                  onClick={() => handlePageChange(pagination.page - 1)}
                  color="dark"
                  size="xs"
                >
                  <ArrowLeft size={16} />
                </Button>
                <span className="self-center text-xs">
                  Page {pagination.page} / {pagination.pages}
                </span>
                <Button
                  disabled={pagination.page === pagination.pages}
                  onClick={() => handlePageChange(pagination.page + 1)}
                  color="dark"
                  size="xs"
                >
                  <ArrowRight size={16} />
                </Button>
              </div>
              <div>
                <span className="text-xs">Total : {pagination.total}</span>
              </div>
            </section>
          </div>

          {/* Modals */}
          {isDeclareTransferModalOpen && (
            <DeclareTransferModalAdminV
              open={isDeclareTransferModalOpen}
              onClose={closeDeclareTransferModal}
              onSuccessClose={closeSuccesDeclareTransferModal}
              entity={franchise}
              adminV={currentCommercial}
              torole={"franchise"}
            />
          )}
          {isRecupereTransModalOpen && (
            <RecupererTransfert
              open={isRecupereTransModalOpen}
              onClose={closeRecuperTransferModal}
              onSuccessClose={closeSuccesRecuperTransferModal}
              entity={franchise}
              adminV={currentCommercial}
              torole={"franchise"}
            />
          )}
        </div>
      )}
    </>
  );
}
